module.exports = __webpack_public_path__ + "media/navi/icon_scroll-00d43f5a.png";